import { render, staticRenderFns } from "./EventDetailsListItem.vue?vue&type=template&id=4efc39d4&scoped=true"
import script from "./EventDetailsListItem.vue?vue&type=script&lang=js"
export * from "./EventDetailsListItem.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsListItem.vue?vue&type=style&index=0&id=4efc39d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc39d4",
  null
  
)

export default component.exports